import {
  GroupProfileCard,
  EntityOwnershipCardWithActions,
} from '@internal/plugin-team-space';
import React from 'react';

import { Paper, Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
  },
  column: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const GroupOverviewCard = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.root} elevation={2}>
      <Grid container spacing={2} alignItems="stretch">
        <Grid item xs={12} md={8}>
          <div className={classes.column}>
            <GroupProfileCard variant="fullHeight" />
          </div>
        </Grid>

        <Grid item xs={12} md={4}>
          <div className={classes.column}>
            <EntityOwnershipCardWithActions
              variant="fullHeight"
              relationsType="aggregated"
              entityFilterKind={[
                'KaaPAccount',
                'Component',
                'Resource',
                'Template',
                'API',
                'System',
                'Repository',
              ]}
            />
          </div>
        </Grid>
      </Grid>
    </Paper>
  );
};
